import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad, CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from "@angular/router";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { CompoApp } from "../CompoApp";
import { RContractXsState } from '../../states/user-rights/topic-based/contract/r-contract-xs.state';

@Injectable()
export class ContractGuard implements CanActivate, CanMatch {

  constructor(
    private app: CompoApp,
    private router: Router,
    private store: Store
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.can();
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.can();
  }

  private can(): Observable<boolean> | Promise<boolean> | boolean {
    const canActivate = this.store.selectSnapshot(RContractXsState.canViewContract);
    if (!canActivate) {
      this.router.navigate(['/home']);
    }
    return canActivate;
  }
}
